import * as React from 'react';
import classnames from 'classnames';

const ConfirmInformationIllustration = ({ className }) => {
  function buildXml() {
    return (
      <svg
        viewBox="0 0 898 500"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classnames('w-1/2', className)}
      >
        <path
          d="M521.364 82.4363C463.835 80.7803 409.045 65.3119 356.762 48.3869C304.478 31.462 252.576 12.7422 196.425 3.77677C160.312 -1.98917 119.014 -2.80421 89.9159 13.3144C61.9099 28.8261 52.8664 55.6095 48.0022 80.4681C44.3346 99.1619 42.1843 118.844 52.2162 136.341C59.1526 148.48 71.5429 158.703 80.0921 170.339C109.832 210.839 88.8147 260.773 56.5775 300.311C41.456 318.857 23.9154 336.554 12.2448 356.297C0.574146 376.04 -4.80162 398.679 5.38632 418.794C15.5049 438.737 39.6178 453.746 65.7423 464.298C118.798 485.714 181.321 491.844 242.284 495.321C377.233 503.003 512.91 499.656 648.224 496.344C698.296 495.113 748.594 493.864 797.861 487.413C825.216 483.833 853.456 478.153 873.295 464.436C898.509 447.026 904.752 417.537 887.861 395.705C859.526 359.08 781.213 349.985 761.366 310.681C750.459 289.048 761.661 264.944 777.502 244.88C811.491 201.839 868.465 164.079 871.465 114.882C873.52 81.0664 846.138 47.2511 803.791 31.2625C759.407 14.5023 697.854 16.6092 665.062 44.3551C631.411 72.916 572.157 83.9364 521.364 82.4363Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M589.234 77.9056C588.738 79.7583 589.837 81.6626 591.69 82.1591C593.543 82.6555 595.447 81.556 595.943 79.7033C596.44 77.8506 595.34 75.9462 593.488 75.4498C591.635 74.9533 589.731 76.0528 589.234 77.9056Z"
          fill="#E1E4E5"
        />
        <path
          d="M609.306 144.717C612.243 144.717 614.624 142.336 614.624 139.399C614.624 136.462 612.243 134.081 609.306 134.081C606.369 134.081 603.988 136.462 603.988 139.399C603.988 142.336 606.369 144.717 609.306 144.717Z"
          fill="#69CE8C"
        />
        <path
          d="M187.862 313.876C183.456 313.876 179.884 317.448 179.884 321.854C179.884 326.261 183.456 329.833 187.862 329.833C192.268 329.833 195.84 326.261 195.84 321.854C195.84 317.448 192.268 313.876 187.862 313.876Z"
          fill="#69CE8C"
        />
        <path
          d="M169.426 152.33C166.336 152.33 163.831 149.825 163.831 146.735C163.831 143.645 166.336 141.14 169.426 141.14C172.517 141.14 175.021 143.645 175.021 146.735C175.021 149.825 172.517 152.33 169.426 152.33Z"
          fill="#69CE8C"
        />
        <path
          d="M125.105 252.184C119.524 252.184 115 247.659 115 242.079C115 236.498 119.524 231.974 125.105 231.974C130.686 231.974 135.21 236.498 135.21 242.079C135.21 247.659 130.686 252.184 125.105 252.184Z"
          fill="#E1E4E5"
        />
        <path
          d="M619.713 323.451C614.132 323.451 609.608 318.927 609.608 313.346C609.608 307.765 614.132 303.241 619.713 303.241C625.294 303.241 629.818 307.765 629.818 313.346C629.818 318.927 625.294 323.451 619.713 323.451Z"
          fill="#E1E4E5"
        />
        <path
          d="M191.785 202.904C192.496 205.556 190.922 208.281 188.27 208.992C185.618 209.703 182.893 208.129 182.182 205.477C181.472 202.825 183.045 200.099 185.697 199.389C188.349 198.678 191.075 200.252 191.785 202.904Z"
          fill="#E1E4E5"
        />
        <path
          d="M591.778 211.247C592.489 213.898 590.915 216.624 588.263 217.335C585.612 218.045 582.886 216.472 582.175 213.82C581.465 211.168 583.038 208.442 585.69 207.731C588.342 207.021 591.068 208.595 591.778 211.247Z"
          fill="#E1E4E5"
        />
        <path
          d="M192.825 98.4125C189.172 98.4125 186.212 95.4518 186.212 91.7995C186.212 88.1473 189.172 85.1865 192.825 85.1865C196.477 85.1865 199.438 88.1473 199.438 91.7995C199.438 95.4518 196.477 98.4125 192.825 98.4125Z"
          fill="#E1E4E5"
        />
        <path
          d="M387.609 371.782H142.44C133.804 371.782 126.804 378.783 126.804 387.418C126.804 396.054 133.804 403.054 142.44 403.054H387.609C396.244 403.054 403.245 396.054 403.245 387.418C403.245 378.783 396.244 371.782 387.609 371.782Z"
          fill="white"
        />
        <path
          d="M387.609 240.441H142.44C133.804 240.441 126.804 247.441 126.804 256.077C126.804 264.712 133.804 271.713 142.44 271.713H387.609C396.244 271.713 403.245 264.712 403.245 256.077C403.245 247.441 396.244 240.441 387.609 240.441Z"
          fill="white"
        />
        <path
          d="M387.609 284.222H142.44C133.804 284.222 126.804 291.223 126.804 299.858C126.804 308.494 133.804 315.494 142.44 315.494H387.609C396.244 315.494 403.245 308.494 403.245 299.858C403.245 291.223 396.244 284.222 387.609 284.222Z"
          fill="white"
        />
        <path
          d="M387.609 152.88H142.44C133.804 152.88 126.804 159.88 126.804 168.516C126.804 177.151 133.804 184.152 142.44 184.152H387.609C396.244 184.152 403.245 177.151 403.245 168.516C403.245 159.88 396.244 152.88 387.609 152.88Z"
          fill="white"
        />
        <path
          d="M421.382 328.001H176.213C167.577 328.001 160.577 335.001 160.577 343.637C160.577 352.272 167.577 359.273 176.213 359.273H421.382C430.017 359.273 437.018 352.272 437.018 343.637C437.018 335.001 430.017 328.001 421.382 328.001Z"
          fill="white"
        />
        <path
          d="M421.382 196.661H176.213C167.577 196.661 160.577 203.662 160.577 212.297C160.577 220.933 167.577 227.933 176.213 227.933H421.382C430.017 227.933 437.018 220.933 437.018 212.297C437.018 203.662 430.017 196.661 421.382 196.661Z"
          fill="white"
        />
        <path
          d="M243.949 313.734C251.022 362.498 217.176 407.76 168.277 414.866C119.412 421.972 74.0487 388.194 66.9427 339.429C59.8707 290.699 93.7497 245.403 142.616 238.297C191.514 231.192 236.877 264.97 243.949 313.734V313.734Z"
          fill="#69CE8C"
        />
        <path
          d="M222.9 316.798C228.289 353.943 202.492 388.462 165.245 393.884C127.999 399.273 93.413 373.543 88.024 336.398C82.636 299.218 108.432 264.699 145.679 259.311C182.926 253.889 217.478 279.618 222.9 316.798V316.798Z"
          fill="white"
        />
        <path
          d="M168.707 365.264L170.666 377.098L159.787 378.798L157.898 367.27C147.019 368.324 136.175 366.658 129.459 363.019L133.307 349.213C139.394 352.273 147.684 353.906 155.624 353.43L152.721 335.781C140.198 334.795 126.066 332.992 123.582 317.894C121.729 306.706 128.515 295.79 145.375 291.199L143.451 279.467L154.33 277.767L156.219 289.295C164.474 288.649 172.765 289.533 179.341 292.287L176.053 306.128C170.001 303.917 164.055 302.999 158.528 303.203L161.501 321.158C174.024 322.008 187.911 323.879 190.36 338.773C192.144 349.791 185.462 360.605 168.707 365.264ZM150.167 320.24L147.684 305.244C142.122 307.42 140.373 310.821 140.933 314.323C141.562 317.996 145.13 319.526 150.167 320.24ZM173.044 342.82C172.45 339.113 168.952 337.617 164.02 336.733L166.433 351.321C171.68 349.315 173.604 346.186 173.044 342.82V342.82Z"
          fill="#69CE8C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.422 167.97H46.679C47.467 167.97 48.101 168.611 48.101 169.392V172.649C48.101 173.437 47.46 174.071 46.679 174.071H43.422C43.0453 174.07 42.6846 173.919 42.4182 173.653C42.1519 173.387 42.0016 173.026 42 172.649V169.392C41.9997 169.205 42.0363 169.02 42.1077 168.848C42.1791 168.675 42.2838 168.518 42.4159 168.386C42.548 168.254 42.7049 168.149 42.8775 168.078C43.0502 168.007 43.2352 167.97 43.422 167.97V167.97ZM54.716 167.97H57.973C58.754 167.97 59.394 168.611 59.394 169.392V172.649C59.394 173.437 58.754 174.071 57.973 174.071H54.716C54.3394 174.07 53.9786 173.919 53.7122 173.653C53.4459 173.387 53.2956 173.026 53.294 172.649V169.392C53.294 168.611 53.935 167.97 54.716 167.97ZM66.015 167.97H69.272C70.053 167.97 70.694 168.611 70.694 169.392V172.649C70.694 173.437 70.053 174.071 69.272 174.071H66.015C65.6383 174.07 65.2776 173.919 65.0112 173.653C64.7449 173.387 64.5946 173.026 64.593 172.649V169.392C64.5927 169.205 64.6293 169.02 64.7007 168.848C64.7721 168.675 64.8768 168.518 65.0089 168.386C65.141 168.254 65.2979 168.149 65.4705 168.078C65.6432 168.007 65.8282 167.97 66.015 167.97V167.97ZM77.308 167.97H80.565C81.346 167.97 81.987 168.611 81.987 169.392V172.649C81.987 173.437 81.346 174.071 80.565 174.071H77.308C76.9303 174.071 76.568 173.922 76.3004 173.655C76.0327 173.389 75.8816 173.027 75.88 172.649V169.392C75.8839 169.015 76.0358 168.655 76.3029 168.389C76.5701 168.123 76.931 167.973 77.308 167.97V167.97ZM88.6 167.97H91.858C92.645 167.97 93.286 168.611 93.286 169.392V172.649C93.286 173.437 92.645 174.071 91.858 174.071H88.6C87.82 174.071 87.179 173.43 87.179 172.649V169.392C87.179 168.611 87.82 167.97 88.6 167.97ZM55.129 180.285H58.386C59.167 180.285 59.807 180.925 59.807 181.706V184.97C59.807 185.751 59.167 186.392 58.386 186.392H55.129C54.7519 186.392 54.3904 186.242 54.1238 185.975C53.8572 185.709 53.7073 185.347 53.707 184.97V181.713C53.7059 181.526 53.742 181.34 53.813 181.167C53.884 180.994 53.9886 180.836 54.1208 180.703C54.253 180.57 54.4101 180.465 54.5831 180.393C54.7562 180.322 54.9417 180.285 55.129 180.285V180.285ZM66.422 180.285H69.679C70.46 180.285 71.101 180.925 71.101 181.706V184.97C71.101 185.751 70.46 186.392 69.679 186.392H66.422C66.0453 186.391 65.6846 186.24 65.4182 185.974C65.1519 185.708 65.0016 185.347 65 184.97V181.713C64.9989 181.526 65.035 181.34 65.106 181.167C65.177 180.994 65.2816 180.836 65.4138 180.703C65.546 180.57 65.7031 180.465 65.8761 180.393C66.0492 180.322 66.2347 180.285 66.422 180.285V180.285ZM77.715 180.285H80.972C81.759 180.285 82.4 180.925 82.4 181.706V184.97C82.4 185.751 81.759 186.392 80.972 186.392H77.715C77.3383 186.391 76.9776 186.24 76.7112 185.974C76.4449 185.708 76.2946 185.347 76.293 184.97V181.713C76.293 180.925 76.934 180.285 77.715 180.285ZM66.015 154.742H69.272C70.053 154.742 70.694 155.383 70.694 156.164V159.421C70.694 160.208 70.053 160.842 69.272 160.842H66.015C65.234 160.842 64.593 160.202 64.593 159.421V156.164C64.5927 155.977 64.6293 155.792 64.7007 155.62C64.7721 155.447 64.8768 155.29 65.0089 155.158C65.141 155.026 65.2979 154.921 65.4705 154.85C65.6432 154.779 65.8282 154.742 66.015 154.742V154.742ZM77.308 154.742H80.565C81.346 154.742 81.987 155.383 81.987 156.164V159.421C81.987 160.208 81.346 160.842 80.565 160.842H77.308C76.52 160.842 75.88 160.202 75.88 159.421V156.164C75.8839 155.787 76.0358 155.427 76.3029 155.161C76.5701 154.895 76.931 154.745 77.308 154.742V154.742Z"
          fill="#E1E4E5"
        />
        <path
          d="M778.37 36H482.249C471.203 36 462.249 44.9543 462.249 56V144.901C462.249 155.947 471.203 164.901 482.249 164.901H778.37C789.415 164.901 798.37 155.947 798.37 144.901V56C798.37 44.9543 789.415 36 778.37 36Z"
          fill="white"
          stroke="#E1E4E5"
          strokeWidth="4"
        />
        <path
          d="M756.225 75.585H566.45C562.271 75.585 558.882 78.9733 558.882 83.153C558.882 87.3327 562.271 90.721 566.45 90.721H756.225C760.405 90.721 763.793 87.3327 763.793 83.153C763.793 78.9733 760.405 75.585 756.225 75.585Z"
          fill="#E1E4E5"
        />
        <path
          d="M684.04 109.35H566.45C562.271 109.35 558.882 112.738 558.882 116.918C558.882 121.098 562.271 124.486 566.45 124.486H684.04C688.22 124.486 691.608 121.098 691.608 116.918C691.608 112.738 688.22 109.35 684.04 109.35Z"
          fill="#E1E4E5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M515.517 132.943C497.701 132.943 483.256 118.295 483.256 100.227C483.256 82.1602 497.701 67.5112 515.517 67.5112C533.334 67.5112 547.779 82.1602 547.779 100.227C547.779 118.295 533.334 132.943 515.517 132.943Z"
          fill="#69CE8C"
        />
        <path
          d="M526.877 94.7749L513.248 109.316L505.066 100.593"
          stroke="white"
          strokeWidth="3.568"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M778.37 191.296H482.249C471.203 191.296 462.249 200.25 462.249 211.296V300.197C462.249 311.243 471.203 320.197 482.249 320.197H778.37C789.415 320.197 798.37 311.243 798.37 300.197V211.296C798.37 200.25 789.415 191.296 778.37 191.296Z"
          fill="white"
          stroke="#E1E4E5"
          strokeWidth="4"
        />
        <path
          d="M756.225 230.881H566.45C562.271 230.881 558.882 234.269 558.882 238.449C558.882 242.629 562.271 246.017 566.45 246.017H756.225C760.405 246.017 763.793 242.629 763.793 238.449C763.793 234.269 760.405 230.881 756.225 230.881Z"
          fill="#E1E4E5"
        />
        <path
          d="M684.04 264.646H566.45C562.271 264.646 558.882 268.034 558.882 272.214C558.882 276.394 562.271 279.782 566.45 279.782H684.04C688.22 279.782 691.608 276.394 691.608 272.214C691.608 268.034 688.22 264.646 684.04 264.646Z"
          fill="#E1E4E5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M515.517 288.24C497.701 288.24 483.256 273.591 483.256 255.524C483.256 237.456 497.701 222.808 515.517 222.808C533.334 222.808 547.779 237.456 547.779 255.524C547.779 273.591 533.334 288.24 515.517 288.24Z"
          fill="#69CE8C"
        />
        <path
          d="M526.877 250.072L513.248 264.612L505.066 255.889"
          stroke="white"
          strokeWidth="3.568"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M778.37 346.593H482.249C471.203 346.593 462.249 355.547 462.249 366.593V455.494C462.249 466.539 471.203 475.494 482.249 475.494H778.37C789.415 475.494 798.37 466.539 798.37 455.494V366.593C798.37 355.547 789.415 346.593 778.37 346.593Z"
          fill="white"
          stroke="#E1E4E5"
          strokeWidth="4"
        />
        <path
          d="M756.225 386.178H566.45C562.271 386.178 558.882 389.567 558.882 393.746C558.882 397.926 562.271 401.314 566.45 401.314H756.225C760.405 401.314 763.793 397.926 763.793 393.746C763.793 389.567 760.405 386.178 756.225 386.178Z"
          fill="#E1E4E5"
        />
        <path
          d="M684.04 419.942H566.45C562.271 419.942 558.882 423.33 558.882 427.51C558.882 431.69 562.271 435.078 566.45 435.078H684.04C688.22 435.078 691.608 431.69 691.608 427.51C691.608 423.33 688.22 419.942 684.04 419.942Z"
          fill="#E1E4E5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M515.517 443.536C497.701 443.536 483.256 428.887 483.256 410.82C483.256 392.753 497.701 378.104 515.517 378.104C533.334 378.104 547.779 392.753 547.779 410.82C547.779 428.887 533.334 443.536 515.517 443.536Z"
          fill="#69CE8C"
        />
        <path
          d="M526.877 405.368L513.248 419.909L505.066 411.186"
          stroke="white"
          strokeWidth="3.568"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M427.613 153.728C423.961 153.728 421 150.767 421 147.115C421 143.463 423.961 140.502 427.613 140.502C431.265 140.502 434.226 143.463 434.226 147.115C434.226 150.767 431.265 153.728 427.613 153.728Z"
          fill="#E1E4E5"
        />
        <defs>
          <linearGradient id="paint0_linear" x1="448.662" y1="0" x2="448.662" y2="500" gradientUnits="userSpaceOnUse">
            <stop stopColor="#69CE8C" />
            <stop offset="1" stopColor="#69CE8C" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  return buildXml();
};

export default ConfirmInformationIllustration;
